// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
}
.calendar-container .calendar-wrapper {
  flex: 1 1;
  max-width: 900px;
}
.calendar-container .calendar-wrapper .rbc-calendar {
  width: 100%;
  line-height: 10px;
  font-size: 19px;
}
.calendar-container .calendar-wrapper .rbc-date-cell {
  text-align: left;
  padding-left: 8px;
  padding-top: 5px;
  font-size: 14px;
}
.calendar-container .calendar-wrapper .rbc-month-view {
  border: 0.5px solid rgba(208, 221, 223, 0.6431372549);
}
.calendar-container .calendar-wrapper .rbc-header {
  background: rgba(126, 195, 204, 0.1725490196);
  padding: 20px;
  font-size: 13px;
}
.calendar-container .calendar-wrapper .rbc-toolbar {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.calendar-container .calendar-wrapper .rbc-toolbar .rbc-toolbar-label {
  font-weight: bold;
  font-size: 18px;
}
.calendar-container .calendar-wrapper .rbc-day-slot {
  height: 60vh;
}
.calendar-container .calendar-wrapper .rbc-time-view .rbc-time-content {
  border-top: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}
.calendar-container .calendar-wrapper .rbc-time-view .rbc-time-content .rbc-timeslot-group {
  min-height: 2em;
}
.calendar-container .calendar-wrapper .selected-date {
  background-color: #2b8ef8 !important;
  color: #fff !important;
}

.provider-times {
  width: 500px;
  margin-left: 10px;
}
.provider-times h3 {
  margin-bottom: 10px;
}
.provider-times .times-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.provider-times .times-grid .time-slot {
  padding: 10px;
  background-color: rgba(126, 195, 204, 0.1725490196);
  border-radius: 4px;
  text-align: center;
  cursor: default;
}
.provider-times .times-grid .time-slot:hover {
  background-color: rgba(162.55, 212, 218.45, 0.1725490196);
}
.provider-times .times-grid .time-slot.selected-time {
  color: white;
  background-color: #2b8ef8 !important;
}

.eha-date-time {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 30px;
}

.eha-date, .eha-time, .eha-duration {
  display: flex;
  align-items: center;
}

.eha-calendar-empty, .eha-clock-1, .eha-hourglass-1 {
  margin-right: 3px;
}

.ca-display {
  margin-right: 30px;
  background-color: rgba(126, 195, 204, 0.1725490196);
  border: 2px solid rgba(43, 142, 248, 0.5);
  border-radius: 7px;
  padding: 12px 25px;
}
.ca-display p {
  margin-bottom: -2px;
}

.ca-modal-title {
  margin-bottom: 10px;
}

.ca-note {
  margin-top: 0;
}

.rbc-toolbar {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.rbc-btn-group {
  display: flex;
}

.rbc-btn-group-right {
  margin-left: auto;
}

.rbc-nav-button {
  border: none !important;
  background: none !important;
  font-size: 13px;
  padding: 10px;
  outline: none !important;
  box-shadow: none !important;
  color: #2b8ef8 !important;
}

.rbc-nav-icon {
  font-size: 16px !important;
  margin-right: 3px;
  margin-left: 3px;
  margin: 0 3px;
}

.eha-date-time {
  margin-top: 0px;
}

.provider-times {
  width: 500px;
  margin-left: 10px;
}
.provider-times h3 {
  margin-bottom: 10px;
}
.provider-times .times-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.provider-times .times-grid .time-slot {
  padding: 10px;
  background-color: rgba(126, 195, 204, 0.1725490196);
  border-radius: 4px;
  text-align: center;
  cursor: default;
}
.provider-times .times-grid .time-slot:hover {
  background-color: rgba(162.55, 212, 218.45, 0.1725490196);
}
.provider-times .times-grid .time-slot.selected-time {
  color: white;
  background-color: #2b8ef8 !important;
}

.eha-date-time {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 30px;
}

.eha-date, .eha-time, .eha-duration {
  display: flex;
  align-items: center;
}

.eha-calendar-empty, .eha-clock-1, .eha-hourglass-1 {
  margin-right: 3px;
}

.ca-display {
  margin-right: 30px;
  background-color: rgba(126, 195, 204, 0.1725490196);
  border: 2px solid rgba(43, 142, 248, 0.5);
  border-radius: 7px;
  padding: 12px 25px;
}

p {
  margin-bottom: -2px;
}

.eha-date-time {
  margin-top: 0px;
}

.ca-modal-title {
  margin-bottom: 10px;
}

.ca-note {
  margin-top: 0;
}

.modal-title {
  text-align: center;
  font-weight: bold;
}

.appointment-details {
  text-align: center;
  margin: 10px 0;
}

.cu-text {
  font-weight: bold;
}

.re-text {
  font-weight: bold;
}

.center-text {
  text-align: center;
  font-weight: bold;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/components/update-booking/_calendar.scss"],"names":[],"mappings":"AAcA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAjBc;AAIhB;AAeE;EACE,SAAA;EACA,gBAAA;AAbJ;AAeI;EACE,WAAA;EACA,iBAAA;EACA,eAAA;AAbN;AAgBI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAdN;AAiBI;EACE,qDAAA;AAfN;AAkBI;EACE,6CAtCY;EAuCZ,aAzCW;EA0CX,eAAA;AAhBN;AAmBI;EAtCF,aAAA;EACA,uBAAA;EACA,mBAAA;EAsCI,8BAAA;EACA,mBAjDU;AAkChB;AAiBM;EACE,iBAAA;EACA,eAAA;AAfR;AAmBI;EACE,YAAA;AAjBN;AAoBI;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;AAlBN;AAoBM;EACE,eAAA;AAlBR;AAsBI;EACE,oCAAA;EACA,sBAAA;AApBN;;AAyBA;EACE,YAAA;EACA,iBAhFc;AA0DhB;AAwBE;EACE,mBAnFY;AA6DhB;AAyBE;EACE,aAAA;EACA,qCAAA;EACA,SAzFY;AAkEhB;AAyBI;EACE,aA5FU;EA6FV,mDA1FY;EA2FZ,kBAAA;EACA,kBAAA;EACA,eAAA;AAvBN;AAyBM;EACE,yDAAA;AAvBR;AA0BM;EACE,YAAA;EACA,oCAAA;AAxBR;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,iBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,mDA7HgB;EA8HhB,yCAAA;EACA,kBAAA;EACA,kBAAA;AA3BF;AA6BE;EACE,mBAAA;AA3BJ;;AA+BA;EACE,mBAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EA1IE,aAAA;EACA,uBAAA;EACA,mBAAA;EA0IA,8BAAA;EACA,mBArJc;AA2HhB;;AA6BA;EACE,aAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,aApKc;EAqKd,wBAAA;EACA,2BAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AA1BF;;AA6BA;EACE,eAAA;AA1BF;;AA6BA;EACE,YAAA;EACA,iBAvLc;AA6JhB;AA4BE;EACE,mBA1LY;AAgKhB;AA6BE;EACE,aAAA;EACA,qCAAA;EACA,SAhMY;AAqKhB;AA6BI;EACE,aAnMU;EAoMV,mDAjMY;EAkMZ,kBAAA;EACA,kBAAA;EACA,eAAA;AA3BN;AA4BM;EACE,yDAAA;AA1BR;AA4BM;EACE,YAAA;EACA,oCAAA;AA1BR;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,mDAlOgB;EAmOhB,yCAAA;EACA,kBAAA;EACA,kBAAA;AA7BF;;AAgCE;EACE,mBAAA;AA7BJ;;AAgCE;EACE,eAAA;AA7BJ;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,aAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AA7BF","sourcesContent":["// Variables\n$padding-small: 10px;\n$padding-medium: 20px;\n$color-primary: #2b8ef8;\n$color-secondary: #7ec3cc2c;\n$border-color: #d0dddfa4;\n\n// Mixins\n@mixin flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.calendar-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: $padding-small;\n\n  .calendar-wrapper {\n    flex: 1;\n    max-width: 900px; \n\n    .rbc-calendar {\n      width: 100%;\n      line-height: 10px;\n      font-size: 19px;\n    }\n\n    .rbc-date-cell {\n      text-align: left;\n      padding-left: 8px;\n      padding-top: 5px;\n      font-size: 14px;\n    }\n\n    .rbc-month-view {\n      border: 0.5px solid $border-color;\n    }\n\n    .rbc-header {\n      background: $color-secondary;\n      padding: $padding-medium;\n      font-size: 13px;\n    }\n\n    .rbc-toolbar {\n      @include flex-center;\n      justify-content: space-between;\n      margin-bottom: $padding-small;\n\n      .rbc-toolbar-label {\n        font-weight: bold;\n        font-size: 18px;\n      }\n    }\n\n    .rbc-day-slot {\n      height: 60vh;\n    }\n\n    .rbc-time-view .rbc-time-content {\n      border-top: 1px solid #ddd;\n      display: flex;\n      flex-direction: column;\n\n      .rbc-timeslot-group {\n        min-height: 2em;\n      }\n    }\n\n    .selected-date {\n      background-color: $color-primary !important;\n      color: #fff !important;\n    }\n  }\n}\n\n.provider-times {\n  width: 500px; \n  margin-left: $padding-small; \n\n  h3 {\n    margin-bottom: $padding-small;\n  }\n\n  .times-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: $padding-small;\n\n    .time-slot {\n      padding: $padding-small;\n      background-color: $color-secondary;\n      border-radius: 4px;\n      text-align: center;\n      cursor: default; \n\n      &:hover {\n        background-color: lighten($color-secondary, 10%);\n      }\n\n      &.selected-time {\n        color: white;\n        background-color: $color-primary !important;\n      }\n    }\n  }\n}\n\n.eha-date-time {\n  display: flex;\n  align-items: center;\n  gap: 10px; \n  padding-left: 30px;\n}\n\n.eha-date, .eha-time, .eha-duration {\n  display: flex;\n  align-items: center;\n}\n\n.eha-calendar-empty, .eha-clock-1, .eha-hourglass-1 {\n  margin-right: 3px; \n}\n\n.ca-display {\n  margin-right: 30px; \n  background-color: $color-secondary;\n  border: 2px solid rgba($color-primary, 0.5);\n  border-radius: 7px;\n  padding: 12px 25px;\n\n  p {\n    margin-bottom: -2px;\n  }\n}\n\n.ca-modal-title {\n  margin-bottom: 10px; \n}\n\n.ca-note {\n  margin-top: 0; \n}\n\n.rbc-toolbar {\n  @include flex-center;\n  justify-content: space-between;\n  margin-bottom: $padding-small;\n}\n\n.rbc-btn-group {\n  display: flex;\n}\n\n.rbc-btn-group-right {\n  margin-left: auto;\n}\n\n.rbc-nav-button {\n  border: none !important;\n  background: none !important;\n  font-size: 13px;\n  padding: $padding-small;\n  outline: none !important;\n  box-shadow: none !important;\n  color: $color-primary !important;\n}\n\n.rbc-nav-icon {\n  font-size: 16px !important;\n  margin-right: 3px;\n  margin-left: 3px;\n  margin: 0 3px;\n}\n\n.eha-date-time {\n  margin-top: 0px;\n}\n\n.provider-times {\n  width: 500px;\n  margin-left: $padding-small; \n\n  h3 {\n    margin-bottom: $padding-small;\n  }\n\n  .times-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: $padding-small;\n\n    .time-slot {\n      padding: $padding-small;\n      background-color: $color-secondary;\n      border-radius: 4px;\n      text-align: center;\n      cursor: default;\n      &:hover {\n        background-color: lighten($color-secondary, 10%);\n      }\n      &.selected-time {\n        color: white;\n        background-color: $color-primary !important;\n      }\n    }\n  }\n}\n\n.eha-date-time {\n  display: flex;\n  align-items: center;\n  gap: 10px; \n  padding-left: 30px;\n}\n\n.eha-date, .eha-time, .eha-duration {\n  display: flex;\n  align-items: center;\n}\n\n.eha-calendar-empty, .eha-clock-1, .eha-hourglass-1{\n  margin-right: 3px; \n}\n\n.ca-display {\n  margin-right: 30px; \n  background-color: $color-secondary;\n  border: 2px solid rgba($color-primary, 0.5);\n  border-radius: 7px;\n  padding: 12px 25px;\n}\n\n  p {\n    margin-bottom: -2px;\n  }\n\n  .eha-date-time {\n    margin-top: 0px;\n  }\n\n.ca-modal-title {\n  margin-bottom: 10px;\n}\n\n.ca-note {\n  margin-top: 0; \n}\n\n.modal-title {\n  text-align: center;\n  font-weight: bold;\n}\n\n.appointment-details {\n  text-align: center;\n  margin: 10px 0;\n}\n\n.cu-text {\n  font-weight: bold;\n}\n\n.re-text {\n  font-weight: bold;\n}\n\n.center-text {\n  text-align: center;\n  font-weight: bold;\n  font-size: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
